var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.254 47.0196L115.927 90.9179C116.334 92.9787 114.992 94.9815 112.931 95.3887L49.2162 107.976C47.1555 108.384 45.1526 107.041 44.7455 104.981L36.0728 61.0826C35.6656 59.0218 37.0078 57.019 39.0684 56.6118L102.783 44.024C104.844 43.6168 106.847 44.9588 107.254 47.0196Z",
    fill: "url(#paint0_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.931 95.3888L49.2166 107.976C47.156 108.384 45.1535 107.041 44.7452 104.981L44.1738 102.088C44.7996 102.283 45.4835 102.331 46.1729 102.195L107.253 47.0186L115.928 90.9174C116.334 92.9781 114.991 94.9806 112.931 95.3888Z",
    fill: "url(#paint1_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13 55.8963V100.643C113.13 102.744 111.426 104.449 109.325 104.449H44.3787C42.2781 104.449 40.5732 102.744 40.5732 100.643V55.8963C40.5732 53.7957 42.2781 52.0908 44.3787 52.0908H109.325C111.426 52.0908 113.13 53.7955 113.13 55.8963Z",
    fill: "url(#paint2_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9737 104.449H44.3787C42.277 104.449 40.5732 102.745 40.5732 100.643V55.8963C40.5732 53.7946 42.2771 52.0908 44.3787 52.0908H109.325C111.427 52.0908 113.13 53.7947 113.13 55.8963V86.2885C113.13 86.8708 112.901 87.4299 112.493 87.8446L97.6481 102.911C96.6785 103.895 95.3549 104.449 93.9737 104.449Z",
    fill: "url(#paint3_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.613 59.2993V92.799C105.079 95.3712 102.078 98.4148 100.056 100.468H49.3183C47.5369 100.468 46.0913 99.0227 46.0913 97.2413V59.2993C46.0913 57.5179 47.5369 56.0723 49.3183 56.0723H104.386C106.167 56.0723 107.613 57.5179 107.613 59.2993Z",
    fill: "url(#paint4_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13 97.5996V100.644C113.13 102.745 111.426 104.449 109.325 104.449H44.3787C42.2781 104.449 40.5732 102.745 40.5732 100.644V97.5996H113.13Z",
    fill: "url(#paint5_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1102 97.5852C46.1202 97.6798 46.1349 97.7727 46.1529 97.8646C46.1562 97.8816 46.1596 97.8987 46.1632 97.9155C46.1824 98.0059 46.2052 98.0949 46.2318 98.1824C46.2365 98.1977 46.2416 98.2129 46.2466 98.2282C46.2752 98.3174 46.3068 98.4052 46.3427 98.4909C46.346 98.4987 46.3497 98.506 46.353 98.5138C46.3883 98.5959 46.4272 98.6759 46.4688 98.7541C46.4749 98.7659 46.4808 98.7777 46.4871 98.7894C46.5297 98.8673 46.5763 98.9426 46.6249 99.0163C46.6358 99.033 46.6468 99.0496 46.658 99.066C46.7065 99.1365 46.7577 99.2051 46.8115 99.2712C46.8249 99.2877 46.8388 99.304 46.8524 99.3204C46.9077 99.3859 46.9651 99.4498 47.0252 99.5105C47.0379 99.5232 47.051 99.5354 47.0638 99.5479C47.1207 99.6035 47.1794 99.6571 47.2404 99.7084C47.2521 99.7182 47.263 99.7285 47.2749 99.7382C47.8315 100.194 48.5426 100.468 49.3177 100.468H100.055C101.638 98.8612 103.819 96.648 105.908 94.5285L88.7643 78.8016C87.4393 77.5862 85.4048 77.5862 84.0798 78.8016L76.4729 85.7798L64.513 73.8268C63.0958 72.1299 60.4444 72.1744 59.0933 73.9624L46.0913 91.1682V97.2412C46.0913 97.3435 46.0972 97.4443 46.1066 97.5443C46.1079 97.5579 46.1087 97.5716 46.1102 97.5852Z",
    fill: "url(#paint6_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.909 94.5289C103.823 96.6439 101.646 98.8533 100.064 100.459L84.6351 100.446L60.5081 100.426L74.7474 87.362L84.0796 78.8012C85.4046 77.5858 87.4392 77.5858 88.7642 78.8012L105.909 94.5289Z",
    fill: "url(#paint7_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7643 78.8013C87.4393 77.5858 85.4047 77.5858 84.0797 78.8013L74.7476 87.362L84.6352 100.446L100.065 100.459C101.646 98.8533 103.823 96.6439 105.909 94.5289L88.7643 78.8013Z",
    fill: "url(#paint8_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8604 81.6423C91.2728 82.1193 90.3476 82.0087 89.914 81.3084L89.9121 81.3065C89.3989 80.4739 88.189 80.4739 87.6756 81.3065V81.3084C87.1623 82.1411 85.9506 82.1411 85.4373 81.3084V81.3065C85.1815 80.8894 84.7498 80.6825 84.3181 80.6825C83.8864 80.6825 83.4546 80.8894 83.1989 81.3065C82.7328 82.0629 81.6915 82.1318 81.1218 81.5151L84.0803 78.8016C85.4045 77.5844 87.4396 77.5844 88.7637 78.8016L91.8604 81.6423Z",
    fill: "url(#paint9_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8604 81.6423C91.2728 82.1193 90.3476 82.0087 89.914 81.3084L89.9121 81.3065C89.3989 80.4739 88.189 80.4739 87.6756 81.3065V81.3084C87.1623 82.1411 85.9506 82.1411 85.4373 81.3084V81.3065C85.1815 80.8894 84.7498 80.6825 84.3181 80.6825C83.8864 80.6825 83.4546 80.8894 83.1989 81.3065C82.7328 82.0629 81.6915 82.1318 81.1218 81.5151L84.0803 78.8016C85.4045 77.5844 87.4396 77.5844 88.7637 78.8016L91.8604 81.6423Z",
    fill: "url(#paint10_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4837 78.4787C61.4619 78.4787 61.4405 78.4798 61.4187 78.4804C61.443 78.2825 61.4556 78.0809 61.4556 77.8764C61.4556 75.1503 59.2456 72.9404 56.5197 72.9404C54.4894 72.9404 52.7455 74.1664 51.9875 75.9184C51.8109 75.8476 51.6183 75.8082 51.4166 75.8082C50.5692 75.8082 49.8823 76.4951 49.8823 77.3425C49.8823 77.6006 49.9464 77.8439 50.0592 78.0573C48.9728 78.4634 48.1992 79.5106 48.1992 80.7387C48.1992 82.3193 49.4808 83.6009 51.0614 83.6009H61.4839C62.8983 83.6009 64.0448 82.4543 64.0448 81.04C64.0448 79.6256 62.8981 78.4787 61.4837 78.4787Z",
    fill: "#008BF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6518 100.467L48.7994 100.426C47.2649 100.177 46.0913 98.8457 46.0913 97.2404V91.1674L59.0935 73.9618C60.4799 72.1273 63.236 72.1273 64.6224 73.962L74.7479 87.3618L84.6355 100.446L84.6518 100.467Z",
    fill: "url(#paint11_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2836 77.4852C66.7104 78.091 65.6782 78.0167 65.2139 77.2657V77.2621C64.9562 76.8467 64.5264 76.6399 64.0946 76.6399C63.6629 76.6399 63.2329 76.8467 62.9754 77.2639C62.7179 77.6792 62.2879 77.888 61.8562 77.888C61.4245 77.888 60.9945 77.6794 60.737 77.2639C60.4795 76.8486 60.0495 76.6399 59.6178 76.6399C59.1861 76.6399 58.7561 76.8485 58.4986 77.2639C58.0361 78.0149 57.0076 78.0892 56.4326 77.4853L59.0936 73.9627C60.4793 72.127 63.2365 72.127 64.6225 73.9627L67.2836 77.4852Z",
    fill: "url(#paint12_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.935 87.1973C112.935 87.1973 112.823 87.5157 112.38 87.9584C112.216 88.1227 97.7351 102.822 97.7351 102.822C96.71 103.863 95.3101 104.449 93.8494 104.449C95.1103 104.449 96.1326 103.427 96.1326 102.166V91.0027C96.1326 88.901 97.8366 87.1973 99.9381 87.1973H112.935Z",
    fill: "url(#paint13_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6927 68.2893C88.6709 68.2893 88.6495 68.2904 88.6277 68.291C88.6519 68.093 88.6646 67.8914 88.6646 67.6869C88.6646 64.9608 86.4546 62.751 83.7287 62.751C81.6984 62.751 79.9545 63.9769 79.1965 65.7289C79.0199 65.6582 78.8273 65.6188 78.6255 65.6188C77.7782 65.6188 77.0913 66.3057 77.0913 67.153C77.0913 67.4111 77.1554 67.6544 77.2682 67.8679C76.1818 68.2739 75.4082 69.3211 75.4082 70.5493C75.4082 72.1299 76.6898 73.4114 78.2704 73.4114H88.6929C90.1073 73.4114 91.2538 72.2649 91.2538 70.8505C91.2538 69.4361 90.1073 68.2893 88.6927 68.2893Z",
    fill: "#008BF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.612 70.6365L99.7127 62.7368C98.3004 61.2534 96.308 60.3271 94.098 60.3271C89.816 60.3271 86.3447 63.7986 86.3447 68.0804C86.3447 70.2904 87.2708 72.2828 88.7544 73.6951L107.612 92.5531V70.6365Z",
    fill: "url(#paint14_linear_1415_18015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0983 75.8337C98.3803 75.8337 101.852 72.3625 101.852 68.0804C101.852 63.7984 98.3803 60.3271 94.0983 60.3271C89.8162 60.3271 86.345 63.7984 86.345 68.0804C86.345 72.3625 89.8162 75.8337 94.0983 75.8337Z",
    fill: "url(#paint15_linear_1415_18015)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1415_18015",
    x1: 75.9846,
    y1: 76.8072,
    x2: 77.7096,
    y2: -8.14219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1415_18015",
    x1: 79.9121,
    y1: 94.5772,
    x2: 82.0889,
    y2: 104.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363F3E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1415_18015",
    x1: 100.237,
    y1: 101.657,
    x2: 108.804,
    y2: 110.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1415_18015",
    x1: 76.8531,
    y1: 50.4406,
    x2: 76.8531,
    y2: 105.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1415_18015",
    x1: 76.8532,
    y1: 68.4285,
    x2: 76.8532,
    y2: 108.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1415_18015",
    x1: 76.8531,
    y1: 100.125,
    x2: 76.8531,
    y2: 105.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1415_18015",
    x1: 75.2142,
    y1: 95.7649,
    x2: 53.0669,
    y2: 73.6192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1415_18015",
    x1: 83.2101,
    y1: 73.4483,
    x2: 83.2101,
    y2: 101.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1415_18015",
    x1: 95.8951,
    y1: 98.1077,
    x2: 73.851,
    y2: 76.0637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1ACEB8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04959C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1415_18015",
    x1: 86.4928,
    y1: 77.5581,
    x2: 86.4928,
    y2: 81.6165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1415_18015",
    x1: 86.133,
    y1: 81.2185,
    x2: 81.9446,
    y2: 77.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1415_18015",
    x1: 65.3725,
    y1: 67.0995,
    x2: 65.3725,
    y2: 102.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1415_18015",
    x1: 61.859,
    y1: 72.6599,
    x2: 61.859,
    y2: 76.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1415_18015",
    x1: 96.5668,
    y1: 88.993,
    x2: 104.066,
    y2: 96.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1415_18015",
    x1: 110.171,
    y1: 84.1485,
    x2: 83.6181,
    y2: 57.5977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#008BF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1415_18015",
    x1: 94.1001,
    y1: 54.6416,
    x2: 94.1001,
    y2: 82.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#FFC954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profileImg.cdd23b0f4cdb78bd37f84950ace2cb1b.svg";
export { ForwardRef as ReactComponent };